import React from 'react';
import { useStoreState } from "easy-peasy";

class AudioEyeSupport extends React.Component {

    constructor() {
        super();
        this.Setting = useStoreState((state) => state.siteSettingsModel);
    }

    setup = () => {
        if(this.Setting.mainSettings.AudioEye !== null){
            
            let hash = this.Setting.mainSettings.AudioEye
            console.log("Loading Audio Eye Support: " + hash)
            var b = function() {
                window.__AudioEyeSiteHash = hash;
                var a = document.createElement("script");
                a.src = "https://wsmcdn.audioeye.com/aem.js";
                a.type = "text/javascript";
                a.setAttribute("async", "");
                document.getElementsByTagName("body")[0].appendChild(a)
                console.log("Audio Eye Support inserted!")
            };
            "complete" !== document.readyState ? window.addEventListener ? window.addEventListener("load", b) : window.attachEvent && window.attachEvent("onload", b) : b();
        }
        return this
    }

    setDYContext = (contex) => {
        
            window.DY = window.DY || {};
            window.DY.recommendationContext = contex;
            return this
    }

    setDYHeaders = () => {
        document.head.innerHTML+=`
        <link rel="preconnect" href="https://cdn.dynamicyield.com"> 
        <link rel="preconnect" href="https://st.dynamicyield.com"> 
        <link rel="preconnect" href="https://rcom.dynamicyield.com"> 
        <link rel="dns-prefetch" href="https://cdn.dynamicyield.com"> 
        <link rel="dns-prefetch" href="https://st.dynamicyield.com"> 
        <link rel="dns-prefetch" href="https://rcom.dynamicyield.com">`

        var api_dynamic = document.createElement('script');

        api_dynamic.setAttribute('src','https://cdn.dynamicyield.com/api/' + process.env.REACT_APP_DY + '/api_dynamic.js');

        document.head.appendChild(api_dynamic);

        var api_static = document.createElement('script');

        api_static.setAttribute('src','https://cdn.dynamicyield.com/api/' + process.env.REACT_APP_DY +'/api_static.js');

        document.head.appendChild(api_static);

        return this;
    }
    sendDYEvent = (event) => {
        if(typeof window.DY !== 'undefined'){
            window.DY.API("event", event)
        }
        
    }
}

export default AudioEyeSupport